import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "mobile-services-end-of-support"
    }}>{`Mobile Services end-of-support`}</h1>
    <InlineAlert variant="error" slots="text" mdxType="InlineAlert" />
    <p>{`Mobile Services reached end-of-life on December 31, 2022. Mobile Services, which supports a mobile-centric UI, acquisition, deep linking, in-app messaging, push notification, and geo-location is no longer supported after this date. Refer to `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/discontinued/using/mobile-services"
      }}>{`Adobe Mobile Services end-of-life FAQ`}</a>{` for more information.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      